/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceDto } from "./DeviceDto";
import {
    DeviceDtoFromJSON,
    DeviceDtoFromJSONTyped,
    DeviceDtoToJSON,
} from "./DeviceDto";

/**
 *
 * @export
 * @interface DevicePricingScheduleGroupDto
 */
export interface DevicePricingScheduleGroupDto {
    /**
     * The device connector indexes that have a pricing schedule assigned.
     * @type {Array<number>}
     * @memberof DevicePricingScheduleGroupDto
     */
    connectorIndexes?: Array<number>;
    /**
     *
     * @type {DeviceDto}
     * @memberof DevicePricingScheduleGroupDto
     */
    device?: DeviceDto;
}

/**
 * Check if a given object implements the DevicePricingScheduleGroupDto interface.
 */
export function instanceOfDevicePricingScheduleGroupDto(
    value: object,
): value is DevicePricingScheduleGroupDto {
    return true;
}

export function DevicePricingScheduleGroupDtoFromJSON(
    json: any,
): DevicePricingScheduleGroupDto {
    return DevicePricingScheduleGroupDtoFromJSONTyped(json, false);
}

export function DevicePricingScheduleGroupDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DevicePricingScheduleGroupDto {
    if (json == null) {
        return json;
    }
    return {
        connectorIndexes:
            json["connectorIndexes"] == null
                ? undefined
                : json["connectorIndexes"],
        device:
            json["device"] == null
                ? undefined
                : DeviceDtoFromJSON(json["device"]),
    };
}

export function DevicePricingScheduleGroupDtoToJSON(
    value?: DevicePricingScheduleGroupDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndexes: value["connectorIndexes"],
        device: DeviceDtoToJSON(value["device"]),
    };
}
